export const ASSISTANT_TURN_EVENT = 'assistenteTurnoAtualizado'
export const ASSISTANT_FALLBACK_POLL_MS = 15000

export function assistantChannel(sessionId) {
    return `assistente.${sessionId}`
}

export function parseAssistantTurnNotice(event) {
    try {
        const raw = typeof event?.data === 'string' ? JSON.parse(event.data) : event?.data
        let payload = raw?.data ?? raw
        if (typeof payload === 'string') {
            payload = JSON.parse(payload)
        }
        const message = payload?.message ?? raw?.message
        if (message !== ASSISTANT_TURN_EVENT) return null
        const sessionId = payload?.session_id ?? raw?.session_id
        if (!sessionId) return null
        return {
            sessionId: String(sessionId),
            turnId: payload?.turn_id ?? null,
            status: payload?.status ?? null,
        }
    } catch {
        return null
    }
}
